<script setup lang="ts">

</script>

<template>
  <div class="dots">
    <div>•</div>
    <div>•</div>
    <div>•</div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.dots
  @apply flex items-center
  @apply text-[#{$global-bg-icon-secondary}]
  :nth-child(1)
    @apply animate-pulse
    @apply animate-delay-0
  :nth-child(2)
    @apply animate-pulse
    @apply animate-delay-250
  :nth-child(3)
    @apply animate-pulse
    @apply animate-delay-500
</style>
